import reduxApi from 'redux-api';
import { tokenOptions, adapterJquery, baseApiUrl, parseAuth } from './ApiHelpers';

const resources = [
  {
    resourceName: 'publisher',
    resources: 'publishers',
  },
  {
    resourceName: 'advertiser',
    resources: 'advertisers',
  },
  {
    resourceName: 'campaign',
    resources: 'campaigns',
  },
  {
    resourceName: 'selfServeCampaign',
    resources: 'self_serve_campaigns',
  },
  {
    resourceName: 'feedCampaign',
    resources: 'feed_campaigns',
  },
  {
    resourceName: 'feedTemplate',
    resources: 'feed_templates',
  },
  {
    resourceName: 'website',
    resources: 'websites',
  },
  {
    resourceName: 'websiteTemplate',
    resources: 'templates',
  },
  {
    resourceName: 'account',
    resources: 'accounts',
  },
  {
    resourceName: 'salesRep',
    resources: 'sales_reps',
  },
  {
    resourceName: 'report',
    resources: 'reports',
  },
  {
    resourceName: 'ad',
    resources: 'ads',
  },
  {
    resourceName: 'publisherReport',
    resources: 'publisher/reports',
  },
  {
    resourceName: 'advertiserReport',
    resources: 'advertiser/reports',
  },
  {
    resourceName: 'emailAlertCampaign',
    resources: 'email_alert/campaigns',
  },
  {
    resourceName: 'statement',
    resources: 'statements',
  },
  {
    resourceName: 'feedLog',
    resources: 'feed_logs',
  },
  {
    resourceName: 'connectionReports',
    resources: 'connection_reports',
  },
];

const apis = {
  userBecome: {
    url: `${baseApiUrl}/v1/admin/users/become`,
    virtual: true,
    helpers: {
      post(data) {
        return [
          {},
          {
            data,
            method: 'POST',
            cb: (resolve, reject, jqXHR) => {
              const auth = jqXHR.getResponseHeader('Authorization');
              const { token, payload, expired, error } = parseAuth(auth);
              if (error) reject(error);
              return resolve({ token, payload, expired, isAuthenticated: true });
            },
          },
        ];
      },
    },
  },
  publisherReportDropdown: {
    url: `${baseApiUrl}/v1/admin/publisher/reports/get_all_publishers`,
    helpers: {
      get() {
        return [
          {},
          {
            method: 'GET',
          },
        ];
      },
    },
  },
  advertiserReportDropdown: {
    url: `${baseApiUrl}/v1/admin/advertiser/reports/report_filters`,
    helpers: {
      get() {
        return [
          {},
          {
            method: 'GET',
          },
        ];
      },
    },
  },
  publisherReportStats: {
    url: `${baseApiUrl}/v1/admin/publisher/reports/get_stats`,
    helpers: {
      get(params) {
        return [
          params,
          {
            method: 'GET',
          },
        ];
      },
    },
  },
  advertiserReportStats: {
    url: `${baseApiUrl}/v1/admin/advertiser/reports/get_stats`,
    helpers: {
      get(params) {
        return [
          params,
          {
            method: 'GET',
          },
        ];
      },
    },
  },
  connectionReportStats: {
    url: `${baseApiUrl}/v1/admin/connection_reports/get_stats`,
    urlOptions: { arrayFormat: 'brackets', delimiter: '&' },
    helpers: {
      get(params) {
        return [
          params,
          {
            method: 'GET',
          },
        ];
      },
    },
  },
  connectionReportFeeds: {
    url: `${baseApiUrl}/v1/admin/connection_reports/feeds`,
    helpers: {
      get(params) {
        return [
          params,
          {
            method: 'GET',
          },
        ];
      },
    },
  },
  websiteStats: {
    url: `${baseApiUrl}/v1/admin/websites/:id`,
    helpers: {
      get(params) {
        return [
          params,
          {
            method: 'GET',
          },
        ];
      },
    },
  },
  templateUpdateDefault: {
    url: `${baseApiUrl}/v1/admin/templates/:id/set_as_default`,
    virtual: true,
    helpers: {
      post(id, data) {
        return [
          { id },
          {
            data,
            method: 'PUT',
          },
        ];
      },
    },
  },
};

const generateApi = () => {
  resources.forEach(r => {
    apis[r.resourceName] = {
      url: `${baseApiUrl}/v1/admin/${r.resources}`,
      urlOptions: { arrayFormat: 'brackets', delimiter: '&' },
      options: {
        method: 'GET',
      },
    };
    apis[`${r.resourceName}Create`] = {
      url: `${baseApiUrl}/v1/admin/${r.resources}`,
      virtual: true,
      helpers: {
        post(data) {
          return [
            {},
            {
              data,
              method: 'POST',
            },
          ];
        },
      },
    };

    apis[`${r.resourceName}Update`] = {
      url: `${baseApiUrl}/v1/admin/${r.resources}/:id`,
      virtual: true,
      helpers: {
        post(id, data) {
          return [
            { id },
            {
              data,
              method: 'PUT',
            },
          ];
        },
      },
    };

    apis[`${r.resourceName}Delete`] = {
      url: `${baseApiUrl}/v1/admin/${r.resources}/:id`,
      virtual: true,
      helpers: {
        post(id) {
          return [
            { id },
            {
              method: 'DELETE',
            },
          ];
        },
      },
    };

    apis[`${r.resourceName}DeleteAll`] = {
      url: `${baseApiUrl}/v1/admin/${r.resources}/destroy_multiple`,
      virtual: true,
      helpers: {
        post(data) {
          return [
            {},
            {
              data,
              method: 'DELETE',
            },
          ];
        },
      },
    };
  });

  return apis;
};

export default reduxApi(generateApi()).use('options', tokenOptions).use('fetch', adapterJquery);
